<template>
  <div>
    <v-btn-toggle
      mandatory
      style="width: 100%"
      v-if="$vuetify.breakpoint.smAndUp"
    >
      <v-btn
        large
        v-for="(item, i) in items"
        :key="`${item.status}--${i}`"
        @click="setSelectStatus(item.status)"
        style="flex: 1"
      >
        <v-icon left :color="handleColorStatus(item.status)" size="10"
          >mdi-circle</v-icon
        >
        {{ item.text }}
      </v-btn>
    </v-btn-toggle>
    <v-select
      v-else
      v-model="select"
      :items="items"
      @change="setSelectStatus"
      item-text="text"
      item-value="status"
      :label="$t('status')"
      prepend-icon="mdi-list-status"
      dense
      filled
      hide-details
      solo-inverted
    ></v-select>
  </div>
</template>
<script>
export default {
  name: "components-common-filters-select-status",
  data: () => ({
    select: 1,
  }),
  computed: {
    items() {
      if (
        this.$route.name == "ListPromotionOnline" ||
        this.$route.name == "CollaboratorListPromotionOnline"
      ) {
        return [
          { text: this.$t("active"), status: 1 },
          { text: this.$t("didSuspended"), status: 0 },
        ];
      } else {
        return [
          { text: this.$t("active"), status: 1 },
          { text: this.$t("pending"), status: 5 },
        ];
      }
    },
  },
  mounted() {
    this.setSelectStatus(this.select);
  },

  methods: {
    setSelectStatus(status) {
      // Set Store
      this.$store.commit("setSelectStatusPlayers", status);
    },

    handleColorStatus(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 5) return "orange";
      // if (status == 3) return "grey";
    },
  },
};
</script>
